import React from "react";
import { User, Search, ShieldCheck } from "lucide-react"; // icons

const approvalsSteps = [
  {
    icon: <User size={36} className="text-[#18181B]" />,
    title: "1. Connect",
    description:
      "Click Connect Wallet on the top right or enter an address in the search bar.",
  },
  {
    icon: <Search size={36} className="text-[#18181B]" />,
    title: "2. Inspect",
    description:
      "Inspect your approvals by using the network selection, sorting and filtering options.",
  },
  {
    icon: <ShieldCheck size={36} className="text-[#18181B]" />,
    title: "3. Revoke",
    description:
      "Revoke the approvals that you no longer use to prevent unwanted access to your funds.",
  },
];

const Approvals = () => {
  return (
    <section className="px-4 py-14 bg-[#000000]">
      <div className="max-w-[1200px] mx-auto text-center">
        {/* Heading */}
        <h2 className="text-3xl font-bold text-white md:text-4xl">
          How To Revoke Your Approvals.
        </h2>

        {/* Cards Grid */}
        <div className="grid gap-8 px-10 mt-12 md:p-0 md:grid-cols-3">
          {approvalsSteps.map((step, index) => (
            <div
              key={index}
              className="flex items-start gap-4 p-6 bg-white rounded-lg shadow-lg"
            >
              {/* Icon */}
              <div className="flex-shrink-0">{step.icon}</div>

              {/* Text */}
              <div className="text-left">
                <h3 className="text-xl font-semibold text-[#18181B]">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm text-[#3F3F46]">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Approvals;
